import * as React from "react";

export default function Users(props) {
  return (
    <svg
      width={42}
      height={41}
      viewBox="0 0 42 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_di_1427_35513)">
        <g clipPath="url(#clip0_1427_35513)">
          <rect
            x={1}
            width={40}
            height={40}
            rx={12}
            fill="url(#paint0_linear_1427_35513)"
          />
          <g
            clipPath="url(#clip1_1427_35513)"
            filter="url(#filter1_dd_1427_35513)"
          >
            <path
              d="M16.5 21C15.61 21 14.74 20.7361 13.9999 20.2416C13.2599 19.7472 12.6831 19.0443 12.3425 18.2221C12.0019 17.3998 11.9128 16.495 12.0865 15.6221C12.2601 14.7492 12.6887 13.9474 13.318 13.318C13.9474 12.6887 14.7492 12.2601 15.6221 12.0865C16.495 11.9128 17.3998 12.002 18.2221 12.3425C19.0443 12.6831 19.7471 13.2599 20.2416 13.9999C20.7361 14.74 21 15.61 21 16.5C20.9987 17.6931 20.5241 18.8369 19.6805 19.6805C18.8369 20.5241 17.6931 20.9987 16.5 21ZM24 28C23.9984 26.6744 23.4711 25.4036 22.5338 24.4662C21.5964 23.5289 20.3256 23.0016 19 23H14C12.6744 23.0016 11.4036 23.5289 10.4662 24.4662C9.52888 25.4036 9.00159 26.6744 9 28L9 32H24V28ZM26.5 17C25.61 17 24.74 16.7361 23.9999 16.2416C23.2599 15.7471 22.6831 15.0443 22.3425 14.2221C22.0019 13.3998 21.9128 12.495 22.0865 11.6221C22.2601 10.7492 22.6887 9.94736 23.318 9.31802C23.9474 8.68869 24.7492 8.2601 25.6221 8.08647C26.495 7.91283 27.3998 8.00195 28.2221 8.34254C29.0443 8.68314 29.7471 9.25991 30.2416 9.99994C30.7361 10.74 31 11.61 31 12.5C30.9987 13.6931 30.5241 14.8369 29.6805 15.6805C28.8369 16.5241 27.6931 16.9987 26.5 17ZM28 19H23C22.8245 19.0081 22.6496 19.0257 22.476 19.053C22.1124 19.8943 21.5754 20.6494 20.9 21.269C22.3663 21.6839 23.6574 22.5654 24.5777 23.78C25.498 24.9946 25.9973 26.4761 26 28H33V24C32.9984 22.6744 32.4711 21.4036 31.5338 20.4662C30.5964 19.5289 29.3256 19.0016 28 19Z"
              fill="url(#paint1_linear_1427_35513)"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_di_1427_35513"
          x={0.5}
          y={0}
          width={41}
          height={41}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={0.25} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1427_35513"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1427_35513"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={0.25} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1427_35513"
          />
        </filter>
        <filter
          id="filter1_dd_1427_35513"
          x={-21}
          y={-18.1015}
          width={84}
          height={84}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={10} />
          <feGaussianBlur stdDeviation={10} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1427_35513"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.89851} />
          <feGaussianBlur stdDeviation={15} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1427_35513"
            result="effect2_dropShadow_1427_35513"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1427_35513"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1427_35513"
          x1={21}
          y1={0}
          x2={21}
          y2={40}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#29282C" />
          <stop offset={1} stopColor="#100F11" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1427_35513"
          x1={8.81456}
          y1={3.06879}
          x2={26.2368}
          y2={28.6055}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <clipPath id="clip0_1427_35513">
          <rect x={1} width={40} height={40} rx={12} fill="white" />
        </clipPath>
        <clipPath id="clip1_1427_35513">
          <rect
            width={24}
            height={24}
            fill="white"
            transform="translate(9 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
